<template>
    <section id="content">
        <div class="container">
            <TituloPagina titulo="Enviar Logo" />
            <steps :items="steps" :value="1" />

            <div id="upload-container">
                <div class="card-panel">
                    <two-image v-model="imagens" :logo_url.sync="empresa.url_logo" :logo_branca_url.sync="empresa.url_logo_branca" />
                </div>
                <div id="form-actions">
                    <button class="btn white black-text" @click="voltar">
                        Voltar
                    </button>
                    <button class="btn btn-default" @click="salvar">
                        Salvar
                    </button>
                </div>
            </div>
        </div>
    </section>
</template>


<script>

import Steps from '@/components/common/Steps.vue';
import TituloPagina from '@/components/common/TituloPagina.vue';
import TwoImage from '@/components/upload/TwoImage';

import { api } from '@/helpers/api';

import modal from "@/helpers/wm-modal";

export default {

    components: {
        Steps,
        TituloPagina,
        TwoImage
    },


    async created()
    {
        const {data: {result: {data: empresa}}} = await api.get(`empresa/${this.$route.params.id}`);

        this.empresa = empresa;
    },


    computed: {

        steps() {

            const id = this.$route.params.id;

            return [
                {
                    title: 'Dados cadastrais',
                    to: {
                        name: 'empresaEditar', 
                        params: {
                            id
                        }
                    }
                },
                {
                    title: 'Enviar Logo',
                    to: {
                        name: 'empresa_upload_logo',
                        params: { id }
                    }
                },

                {
                    title: 'Tema',
                    to: {
                        name: 'empresa_tema',
                        params: { id }
                    }
                }
            ];
        }
    },


    data() {
        return {
            empresa: {},
            imagens: {}
        }
    },

    methods:
    {
        async salvar () {

            const empresa = this.empresa;

            let form = new FormData();

            if ( this.imagens.logo )
            {
                form.append('logo', this.imagens.logo, 'logo.png');
            }

            if ( this.imagens.logo_branca )
            {
                form.append('logo_branca', this.imagens.logo_branca, 'logo_branca.png');
            }

            await api.post(`empresa/${empresa.empresa_id}/upload-logos`, form);

            this.$router.push({name: 'empresa_tema', params: {id: empresa.empresa_id}})
        },


        voltar() {

            this.$router.push({
                name: 'empresaEditar',
                params: {
                    id: this.empresa.empresa_id
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
#upload-container{
    width: 850px;
    max-width: 100%;
    margin: 50px auto;
}

#form-actions{
    justify-content: space-between;
    display: flex;
}

</style>



// WEBPACK FOOTER //
// src/components/empresas/UploadLogos.vue